import React from 'react'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardMedia, Chip, Grid } from '@mui/material'

import { isScreenSizeSmall } from '../../components/common/utils'

export const EmptyState = () => {
  const { t } = useTranslation()
  return (
    <Card
      sx={{
        minHeight: '200px',
        boxShadow: 'none',
        borderRadius: '0px',
      }}
    >
      <CardContent sx={{ height: '100%' }}>
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <CardMedia sx={{ objectFit: 'contain' }}>
              <svg
                width={isScreenSizeSmall() ? '200' : '90'}
                height={isScreenSizeSmall() ? '200' : '90'}
                viewBox="0 0 90 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="44.999" cy="45" r="39" fill="#EDEDF7" />
                <path
                  d="M68.1816 21.2488C68.1816 25.3872 58.0699 28.7421 44.9952 28.7421C31.9205 28.7421 21.818 25.3872 21.818 21.2488C21.818 17.1103 31.9205 13.7554 44.9952 13.7554C58.0699 13.7554 68.1816 17.1103 68.1816 21.2488Z"
                  fill="#DBDDFF"
                />
                <path
                  d="M68.1816 21.2488C68.1816 25.3872 58.0699 28.7421 44.9952 28.7421C31.9205 28.7421 21.818 25.3872 21.818 21.2488L21.8185 36.0441L21.8185 51.1257C21.8217 55.2633 32.4982 58.6231 45.571 58.6231C46.3992 58.6231 47.2133 58.6097 48.0117 58.5835C48.3299 58.5731 48.6456 58.5606 48.9587 58.5462C49.2523 58.5326 49.5435 58.5173 49.8324 58.5003C59.0727 57.9566 65.8985 55.6613 67.707 52.7186C68.019 52.2109 68.1816 51.684 68.1816 51.1435L68.1816 21.2488Z"
                  fill="#DBDDFF"
                />
                <path
                  d="M68.1816 51.1435C68.1816 51.684 68.019 52.2109 67.707 52.7186C65.8985 55.6613 59.0727 57.9566 49.8324 58.5003C49.5435 58.5173 49.2523 58.5326 48.9587 58.5462C48.6456 58.5606 48.3299 58.5731 48.0117 58.5835C47.2133 58.6097 46.3992 58.6231 45.571 58.6231C32.4982 58.6231 21.8217 55.2633 21.8185 51.1257L21.8185 67.977C22.3415 71.095 33.2639 73.7554 45.5643 73.7554C58.639 73.7554 68.1811 70.8843 68.1816 67.977V51.1435Z"
                  fill="#DBDDFF"
                />
                <path
                  d="M68.1816 21.2488C68.1816 25.3872 58.0699 28.7421 44.9952 28.7421C31.9205 28.7421 21.818 25.3872 21.818 21.2488C21.818 17.1103 31.9205 13.7554 44.9952 13.7554C58.0699 13.7554 68.1816 17.1103 68.1816 21.2488Z"
                  fill="white"
                />
                <path
                  d="M68.1816 21.2488C68.1816 25.3872 58.0699 28.7421 44.9952 28.7421C31.9205 28.7421 21.818 25.3872 21.818 21.2488M68.1816 21.2488C68.1816 17.1103 58.0699 13.7554 44.9952 13.7554C31.9205 13.7554 21.818 17.1103 21.818 21.2488M68.1816 21.2488L68.1816 51.1435V52.8876M21.818 21.2488L21.8185 36.0441M68.1811 36.0154C68.1811 40.1539 58.6452 43.495 45.5705 43.495C32.5468 43.495 21.9013 40.1603 21.8185 36.0441M21.8185 36.0441C21.8182 36.028 21.818 36.0118 21.818 35.9957M21.8185 36.0441L21.8185 51.1257M21.8185 51.1257C21.8217 55.2633 32.4982 58.6231 45.571 58.6231C48.2274 58.6231 50.7873 58.523 53.4283 58.2512M21.8185 51.1257L21.8185 67.977C22.3415 71.095 33.2639 73.7554 45.5643 73.7554C46.8511 73.7554 49.4131 73.6511 51.1563 73.5852"
                  stroke="#212121"
                  strokeLinecap="round"
                />
                <path
                  d="M76.5 67.2554C76.5 73.8828 71.1274 79.2554 64.5 79.2554C57.8726 79.2554 52.5 73.8828 52.5 67.2554C52.5 60.628 57.8726 55.2554 64.5 55.2554C71.1274 55.2554 76.5 60.628 76.5 67.2554Z"
                  fill="white"
                  stroke="#212121"
                />
                <path
                  d="M65.7488 73.5051C65.7488 74.1955 65.1891 74.7551 64.4988 74.7551C63.8084 74.7551 63.2488 74.1955 63.2488 73.5051C63.2488 72.8148 63.8084 72.2551 64.4988 72.2551C65.1891 72.2551 65.7488 72.8148 65.7488 73.5051Z"
                  fill="#212121"
                />
                <path
                  d="M61.0479 63.1743C61.2136 61.2736 63.9762 59.3321 66.4876 60.9691C67.7215 61.8318 68.2299 64.0708 67.252 65.2932C66.4876 66.3196 65.5454 66.8527 64.948 67.63C64.3505 68.4072 64.4422 69.874 64.4422 69.874"
                  stroke="#212121"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </CardMedia>
          </Grid>
        </Grid>
        <Grid item container justifyContent="center" alignItems="center">
          <Chip
            sx={{
              height: isScreenSizeSmall()
                ? 'calc(var(--small-screen-font-size) + 10px)'
                : 'inherit',
              fontSize: isScreenSizeSmall()
                ? 'calc(var(--small-screen-font-size))'
                : 'inherit',
            }}
            label={t('no_record_found')}
            color="primary"
          />
        </Grid>
      </CardContent>
    </Card>
  )
}
